export default "__VITE_ASSET__en_Ir4ea__"